import { SelectOptions } from 'components/core/Select/AppSelect';

export const arrayOfFives = (firstOption: number) => {
  return Array.from(Array(5).keys()).map((_item, index) => index * 5 + firstOption);
};

export const selectOptionsFromArrayOfFives = (arr: number[]): SelectOptions<number> => {
  return arr.map(amount => {
    return {
      value: amount,
      label: amount.toString() + '%',
    };
  });
};

export const selectOptionsFromArrayOfNumbers = (arr: number[]): SelectOptions<number> => {
  return arr.map(amount => ({
    value: amount,
    label: amount.toString(),
  }));
};

export const validRange = (upper: number, lower: number) => {
  return upper - lower <= 20;
};
